import { Http } from 'services/http';
import { API_CHAT_URL } from 'consts/common.const';

export interface RequestDataSetting {
  _id?: string;
  is_profile_tagging?: boolean;
  appearance?: string;
  text_size?: number;
  auto_delete_after?: string;
  is_notify_message?: boolean;
  is_notify_sound?: boolean;
  is_show_sum_msg?: boolean;
  is_notify_desktop?: boolean;
  is_active_status?: boolean;
  limit_number_of_conversation?: number;
  __v?: number;
}

export const updateSettingChat = (id: string, data: RequestDataSetting) => {
  return Http.request({
    method: 'POST',
    url: `${API_CHAT_URL}/common/update-setting/${id}`,
    body: data,
  });
};
